export default {
    apply: 'Ok',
    cancel: 'Limpar',
    from: 'De',
    to: 'Até',
    customRangeLabel: 'Período',
    ranges: {
        last_7_days: 'Últimos 7 Dias',
        last_30_days: 'Últimos 30 Dias',
        current_month: 'Mês Atual',
        last_month: 'Último Mês',
        current_year: 'Ano Atual',
        last_year: 'Último Ano',
    },
}
